<div class="formTbS">
  <mat-form-field class="largoFm">
    <mat-label>Buscar</mat-label>
    <input
      matInput
      (keyup)="applyFilter($event.target.value)"
      placeholder="Ej. LAGO"
      #input
    />
    <mat-icon matSuffix color="accent">search</mat-icon>
  </mat-form-field>
</div>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Empresas</th>
      <td mat-cell *matCellDef="let element">
        <button
          (click)="injectData(element.sEmpresa)"
          mat-icon-button
          color="basic"
        >
          <mat-icon>Guardar</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="sNombre">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        {{ element.sNombre }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0"
          >No hay resultados para "{{ input.value }}"</span
        >
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
</div>
